import { render, staticRenderFns } from "./zhanghu.vue?vue&type=template&id=4bf9b5c4&scoped=true&"
import script from "./zhanghu.vue?vue&type=script&lang=ts&"
export * from "./zhanghu.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bf9b5c4",
  null
  
)

export default component.exports